import { InjectionToken } from '@angular/core';

import { RlePortalLibConfig } from './rle-portal-lib-config.interface';

export const LIB_CONFIG = new InjectionToken<RlePortalLibConfig>('RlePortalLibConfig');
